import type { IPromotionRepository } from '../repositories/IPromotionRepository.js';
import type { PromotionScheme } from '../entities/PromotionScheme.js';

export interface UpdateSchemeUseCaseDeps {
  promotionRepository: IPromotionRepository;
}

export const createUpdateSchemeUseCase = ({ promotionRepository }: UpdateSchemeUseCaseDeps) => {
  return async (id: string, data: Partial<PromotionScheme>): Promise<PromotionScheme> => {
    return promotionRepository.updateScheme(id, data);
  };
};
